import { useId, type FC } from "react";
import { getPositiveNumber } from "../deckGeometry";
import type { SupportGraphicProps } from "../finishedDeckSectionGeometry";

export const GRANULO_SUPPORT_WIDTH_MM = 60;
export const GRANULO_SUPPORT_THICKNESS_MM = 8;

// Always GRANULO_SUPPORT_THICKNESS_MM tall: heightMm is only taken out of the props so it doesn't
// reach the DOM.
const Granulo: FC<SupportGraphicProps> = ({ heightMm, widthMm, ...props }) => {
  const artworkId = useId().replaceAll(":", "");
  const patternId = `${artworkId}-granulo-pattern`;
  const drawingWidthMm = getPositiveNumber(widthMm, GRANULO_SUPPORT_WIDTH_MM);
  const borderInset = 0.18;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${drawingWidthMm} ${GRANULO_SUPPORT_THICKNESS_MM}`}
      aria-hidden="true"
      fill="none"
      shapeRendering="geometricPrecision"
      {...props}
    >
      <defs>
        <pattern id={patternId} width="10" height="8" patternUnits="userSpaceOnUse">
          <rect x="0" y="0" width="10" height="8" fill="#050607" />
          <circle cx="1.1" cy="1.1" r="0.85" fill="#1a1d22" />
          <circle cx="3.6" cy="0.8" r="0.55" fill="#2a2f36" />
          <circle cx="6.2" cy="1.3" r="0.95" fill="#11151a" />
          <circle cx="8.8" cy="0.9" r="0.62" fill="#20242a" />
          <circle cx="2.2" cy="3.1" r="1.05" fill="#0f1317" />
          <circle cx="4.8" cy="3.5" r="0.7" fill="#252a31" />
          <circle cx="7.6" cy="3.2" r="1.1" fill="#171b20" />
          <circle cx="0.4" cy="5.3" r="0.75" fill="#2c3138" />
          <circle cx="3.1" cy="6" r="1.15" fill="#161a1f" />
          <circle cx="5.9" cy="5.5" r="0.82" fill="#30353d" />
          <circle cx="8.9" cy="6.3" r="1.05" fill="#101419" />
          <circle cx="6.8" cy="7.5" r="0.55" fill="#22272d" />
          <path
            d="M0 2.2 C2.4 1.4 4.1 2.9 6.3 2 S8.8 1.7 10 2.4"
            fill="none"
            stroke="#363c44"
            strokeOpacity="0.28"
            strokeWidth="0.18"
          />
          <path
            d="M0 6.9 C2.1 6.1 4.2 7.3 6.4 6.4 S8.7 5.9 10 6.6"
            fill="none"
            stroke="#000000"
            strokeOpacity="0.42"
            strokeWidth="0.2"
          />
        </pattern>
      </defs>

      {/* CORPO SUPPORTO GRANULO */}
      <rect x="0" y="0" width={drawingWidthMm} height={GRANULO_SUPPORT_THICKNESS_MM} fill={`url(#${patternId})`} />
      <rect
        x={borderInset}
        y={borderInset}
        width={Math.max(0, drawingWidthMm - borderInset * 2)}
        height={Math.max(0, GRANULO_SUPPORT_THICKNESS_MM - borderInset * 2)}
        fill="none"
        stroke="#11161b"
        strokeWidth="0.35"
      />
    </svg>
  );
};

export default Granulo;
